<template>
  <div>

    <div>
      <vxe-grid ref='xGrid' v-bind="gridOptions" @cell-click='checkRel' @cell-dblclick="noEdit"
        @checkbox-change="checkboxChangeEvent" @checkbox-all="checkboxChangeEvent">

        <template #tools>
          <div style="display: flex;gap:10px">
            <div>
              <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="searchAddRel = true"
                :disabled="!addTableListPriv || !workFlowStatus">{{ $t('message.button.add') }}
              </el-button>
              <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox(1)"
                :disabled="!removeTableListPriv || !workFlowStatus">{{ $t('message.button.delete') }}
              </el-button>
            </div>


            <div class="edit-table" style="margin-left: auto;">

              <el-button class="btn btn7" icon="el-icon-document-checked" @click="getUpdateEvent(1)" v-if="!editShow"
                :disabled="!workFlowStatus">{{ $t('message.button.save')
                }}</el-button>
              <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave(1)" v-if="!editShow"
                :disabled="!workFlowStatus">{{ $t('message.button.cancel')
                }}</el-button>

            </div>
          </div>
        </template>
        <template #img1_default="{ row }">
          <div>
            <el-tooltip effect="light" placement="left">
              <div slot="content">{{ $t('message.tips.inLinkage') }}</div>
              <i :class="row.relType"></i>
            </el-tooltip>
          </div>
        </template>
        <template #bottom>
          <Bottom-Tips :data="{ selectRecords: selectRecords.length, totalRecords }" />
        </template>
      </vxe-grid>

    </div>

    <div class="line-1"></div>

    <div v-if="chooseRel">
      <ul class="content-title">
        <li>
          {{ tabTitle + "-" + $t('message.title.relationship') }}
        </li>
      </ul>

      <div class="line-1"></div>

      <div style="padding: 10px 20px">

        <div>
          <vxe-grid ref='xGridNext' v-bind="gridOption2" @cell-dblclick="noEdit" @checkbox-change="checkboxChangeEvent2"
            @checkbox-all="checkboxChangeEvent2">
            <template #tools>
              <div style="display: flex;">

                <el-button class="btn btn1" style="margin-left: 0;" icon="el-icon-circle-plus-outline"
                  @click="searchAddRelNext = true" :disabled="!addTableListPriv || !workFlowStatus">{{
                    $t('message.button.add') }}
                </el-button>
                <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox(2)"
                  :disabled="!removeTableListPriv || !workFlowStatus">{{ $t('message.button.delete') }}
                </el-button>

                <div class="edit-table">

                  <el-button class="btn btn7" icon="el-icon-document-checked" @click="getUpdateEvent(2)"
                    v-if="!editShow" :disabled="!workFlowStatus">{{
                      $t('message.button.save')
                    }}</el-button>
                  <el-button class="btn btn8" icon="el-icon-circle-close" @click="closeSave(2)" v-if="!editShow"
                    :disabled="!workFlowStatus">{{
                      $t('message.button.cancel')
                    }}</el-button>

                </div>
              </div>
            </template>
            <template #img1_default="{ row }">
              <div>
                <el-tooltip effect="light" placement="left">
                  <div slot="content">{{ $t('message.tips.inLinkage') }}</div>
                  <i :class="row.relType"></i>
                </el-tooltip>
              </div>
            </template>
            <template #bottom>
              <Bottom-Tips :data="{ selectRecords: selectRecord2.length, totalRecord2 }" />
            </template>
          </vxe-grid>
        </div>
        <!-- 表格区域 -->
      </div>
    </div>

    <el-dialog class="searchAddBomList" v-if='searchAddRel' :title="$t('message.title.add')"
      :visible.sync="searchAddRel" :close-on-click-modal="false" :close-on-press-escape="false">
      <RelSearchAdd @listDbClick="addList"></RelSearchAdd>
    </el-dialog>

    <el-dialog class="searchAddRedLineList" v-if='searchAddRelNext' :visible.sync="searchAddRelNext"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <RelSearchAdd @listDbClick="addNextList"></RelSearchAdd>
    </el-dialog>

    <el-dialog v-if="cascaderShow" class="searchAddBomList" :title="$t('message.title.add')"
      :visible.sync="cascaderShow" @close="closeCascaderShow">
      <div style="height:270px;">
        <div style="margin:60px auto;padding-left:50px">
          <el-cascader v-model="cascaderValue" :options="cascaderList" :props="cascaderProps" :show-all-levels="true"
            size="small" ref="cascaderAddr" style="width:75%"></el-cascader>
          <el-button size="small" type="primary" style="margin-left:10px" @click="getCascadeValue">{{
            $t("message.button.affirm") }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//;
import RelSearchAdd from '@/components/relSearchAdd.vue'; //引进菜单模板
import RelSearchAddNext from '@/components/relSearchAdd.vue';
import { getTabIndex } from "@/utils/index.js"
import axios from "axios";
export default {
  data() {
    return {
      redLine: true,
      tabTitle: '',
      num: 0,
      chooseRel: false,

      searchAddRel: false, //添加窗口开关
      searchAddRelNext: false, //添加窗口开关
      oldTableValue: {},
      redLineBtn: true,
      version: "",

      selectRecords: [],
      totalRecords: "",
      gridOptions: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        autoResize: true,
        rowId: 'id',
        height: "420",
        size: "small",
        columns: [],
        data: [],
        printConfig: {},

        toolbarConfig: {
          zoom: true,
          custom: true,
          print: true,
          slots: {
            buttons: "tools",
          },
        },
        treeConfig: {
          lazy: true,
          children: 'children',
          hasChild: 'hasChildren',
          loadMethod: this.loadChildrenMethod
        },
        editConfig: {
          trigger: 'dblclick',
          mode: 'cell',
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: 'cell'
        },
      },

      selectRecord2: [],
      totalRecord2: "",
      gridOption2: {
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: 'id',
        height: "220",
        size: "small",
        columns: [],
        data: [],
        printConfig: {},

        toolbarConfig: {
          zoom: true,
          custom: true,
          print: true,
          slots: {
            buttons: "tools",
          },
        },
        treeConfig: {
          lazy: true,
          children: 'children',
          hasChild: 'hasChildren',
          loadMethod: this.loadChildrenMethod
        },
        editConfig: {
          trigger: 'dblclick',
          mode: 'cell',
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: 'cell'
        },
      },


      editShow: false,
      leftShow: true,
      showBtn: false,
      workFlowStatus: true,//变更工作流状态

      loading: true,
      cols: [], //表头
      cols2: [], //表头
      rols: [], //表体所有内容
      rols_text: [], //表体显示内容
      tableShow: false, //显示table
      get_change_info: "", //父组件传来的值
      select_list: {},
      childsTable: [], //子列表集合
      childsIndex: [], //子列表index集合

      checkRow: {},
      //子 Relationship 数据
      nextCtrObjId: '',
      nextCtrObjClassId: '',

      //权限
      addTableListPriv: false,
      removeTableListPriv: false,

      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      cascaderProps: {}
    }
  },
  mounted() { },
  components: {
    RelSearchAdd,
    RelSearchAddNext
  },
  methods: {
    checkboxChangeEvent({ records }) {
      const $grid = this.$refs.xGrid;
      this.selectRecords = records;
    },
    checkboxChangeEvent2({ records }) {
      const $grid = this.$refs.xGridNext;
      this.selectRecord2 = records;
    },
    tabClick(res, index) {
      this.num = index;
    },

    removeCheckbox(grid) { //删除
      var removeRow;
      if (grid == 1) {
        removeRow = this.$refs.xGrid.getCheckboxRecords();
      } else {
        removeRow = this.$refs.xGridNext.getCheckboxRecords();
      }

      var del_table = [];
      var vm = this;
      if (removeRow.length == 0) {
        return false
      } else {
        for (let i = 0; i < removeRow.length; i++) {

          del_table.push(removeRow[i].rowId);
        };
        var objId = { //获取change
          ... this.$store.state.objectId,
          //id: this.$store.state.objId_,
          //classId: this.$store.state.classId_,
          // subClassId: this.$store.state.subClassId_
        };
        //console.log(del_table);
        var relationshipMapVo = {
          delIds: del_table,
          objectId: objId
        };
        //console.log(delRelData);
        axios.post('/pmdm/relationship/deleteRelationShip', relationshipMapVo).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            //console.log(res);
            if (grid == 1) {
              this.getRelInfo();
              this.gridOption2.data = [];
            } else {
              this.checkRel(this.checkRow);
            }

          }
        })
          .catch(function (error) {
            console.log(error);
          });
      }

    },
    addList(row) { //添加
      console.log(row);

      // this.searchAddRel = false;
      // let insertBom = row.map(i => {
      //   return {childId:i.id,'1003001':i.itemNumber,itemId:this.$store.state.objectId.id}
      // });
      let relationshipMapVo = {};
      let arr = row.map(i => {
        console.log(i);
        // baseClassId = '';
        // let baseClassId = parseInt(arr.itemClassId.toString().substr(0, 3));
        //  console.log(baseClassId);
        //  if(baseClassId !== 901 || baseClassId !== 902){
        return {
          ctrObjid: this.$store.state.objectId.id,
          ctrObjtype: this.$store.state.objectId.classId,
          effObjid: i.itemId,
          effObjtype: i.itemClass,
          name: i[0],
          relType: '3',
        };
        //  } else {
        //    return {
        //   ctrObjid:this.$store.state.objId_,
        //   ctrObjtype:this.$store.state.classId_,
        //   effObjid:i.itemId,
        //   effObjtype:i.itemClass,
        //   name:i[1],
        //   };
        //  }
      }
      )
      // console.log(row);
      // console.log(row[0][0]);
      // console.log(arr);
      relationshipMapVo.relationshipVoList = arr
      axios.post('/pmdm/relationship/saveRelationship', relationshipMapVo)
        .then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
          };
          this.getRelInfo();
        })
        .catch();


    },
    addNextList(row) { //添加
      //console.log(row);
      if (row) {
        // this.searchAddRelNext = false;

        let relationshipMapVo = {};
        let arr = row.map(i => {
          return {
            ctrObjid: this.nextCtrObjId,
            ctrObjtype: this.nextCtrObjClassId,
            effObjid: i.itemId,
            effObjtype: i.itemClass,
          }
        }
        )
        // console.log(relationshipVo);
        relationshipMapVo.relationshipVoList = arr

        axios.post('/pmdm/relationship/saveRelationship', relationshipMapVo)
          .then(res => {
            console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: 'success'
              });
              this.checkRel(this.checkRow);
            }
          })
          .catch();
      }
    },
    handleClose(done) {
      this.$confirm(this.$t('message.confirm.close'))
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    handleClose2(done) {
      this.$confirm(this.$t('message.confirm.close'))
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    closeSave(v) {
      if (v == 1) {
        this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
      } else {
        this.$refs.xGridNext.revertData(); //清除所有保存，删除，添加记录
      }

    },
    noEdit({ row, columnIndex }) {
      if (column.editRender.cascaderType && this.editTable) {
        this.cascaderList = column.editRender.cascadeOptions;
        let m = row[[column.property]];
        if (column.editRender.props.multiple) {
          this.cascaderValue = m ? m.map((i) => { return this.getParentIdList(this.cascaderList, i) }) : ''
          this.cascaderProps.multiple = true;
        } else {
          this.cascaderProps.multiple = false;
          this.cascaderValue = m;
        }
        this.cascaderProps.checkStrictly = true;
        this.tempData = { row, column }
        this.cascaderShow = true;
        console.log(this.cascaderValue);
      }
    },
    getUpdateEvent(e) {
      var xGrid_;
      var columns;
      var cols_;

      if (e == 1) {
        xGrid_ = this.$refs.xGrid;
        columns = this.gridOptions.columns;
        cols_ = this.cols;
      } else {
        xGrid_ = this.$refs.xGridNext;
        columns = this.gridOption2.columns;
        cols_ = this.cols2;
      }
      console.log(xGrid_);
      let updateRecords = xGrid_.getUpdateRecords(); //获取修改的行
      console.log(updateRecords);
      var cols_length = cols_;
      // console.log(cols_length);
      var updateRel = [];
      if (updateRecords.length !== 0) {//判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i]);
          // var cols_length = this.cols;
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
            console.log(cols_length);
            if (updateNewData) {
              for (let k = 0; k < columns.length; k++) {
                var obj = {};
                if (cols_length[j] == columns[k].attid) {
                  var quantity = cols_length[j];
                  obj.id = updateRecords[i].rowId;
                  console.log(columns[k]);
                  if (columns[k].editRender.props) {//处理多选和单选
                    if (columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(";")
                    } else if (columns[k].editRender.props.type == "datetime") {
                      // obj[quantity] = updateRecords[i][j].format("yyyy-MM-ddThh:mm:ss");
                      obj[quantity] = this.format(updateRecords[i][j], "yyyy-MM-ddThh:mm:ss");
                      console.log(obj[quantity]);
                    } else {
                      if (updateRecords[i][j] == null) {
                        obj[quantity] = "";
                      } else {
                        obj[quantity] = updateRecords[i][j];
                      }
                    }
                  } else {
                    if (updateRecords[i][j] == null) {
                      obj[quantity] = "";
                    } else {
                      obj[quantity] = updateRecords[i][j];
                    }
                  };
                  updateRel.push(obj);
                }
              }
            }
          }
        };
        console.log(updateRel);
        //var change_info = this.$store.state.change_info;
        var updateRelData = {//post更改的值
          tableId: 200,
          updateShip: this.ArrayFilter(updateRel)
        };
        console.log(updateRelData);
        axios.post('/pmdm/items/updateTable', updateRelData)
          .then(res => {
            //console.log(res);
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: 'success'
              });
              if (e == 1) {
                this.getRelInfo();
              } else {
                this.checkRel(this.checkRow);
              }
              //xGrid_.revertData();
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      };

    },
    ArrayFilter(l) {
      let arr = l
      let list = arr.reduce((pre, cur) => {
        let target = pre.find(ee => ee.id == cur.id)
        if (target) {
          Object.assign(target, cur)
        } else {
          pre.push(cur)
        }
        return pre
      }, [])
      return list
    },
    activeRowMethod({ row }) {
      // if (row.disable) {
      //   return false
      // };
      // return true
      return !row.disable
    },
    editDisabledEvent({
      row,
      column
    }) {
      this.$message.error(this.$t('message.error.noEdit'),)
    },
    editClick: function () {
      //console.log(this.$refs.singleTable);
      this.editShow = false;
    },

    getRelInfo() {
      this.$emit('refreshTab');
      console.log(111, this.$refs.xGrid);
      var change_info = this.$store.state.change_info;
      if (this.get_change_info == "") {
        change_info = this.$store.state.change_info;
        //console.log(change_info);
      } else {
        change_info = this.get_change_info;
      };
      //console.log(change_info);

      var obj_get = { //获取change
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
        //classId: this.$store.state.classId_,
        //subClassId: this.$store.state.subClassId_,
        changeId: change_info.changeId,
        changeClassId: change_info.changeClassId,
        changeSubClassId: change_info.changeSubClassId,
        tableId: 200
      };
      //console.log(obj_get);
      // var loadTableUrl = `/userGroup/loadTable${this.params(obj_get)}`;
      // console.log(627,this.relUrl);

      let loadTableUrl = '';
      if (this.relUrl == "quality") {
        loadTableUrl = `/pqm/${this.relUrl}/loadTable${this.params(obj_get)}`;
      } else {
        loadTableUrl = `/pmdm/${this.relUrl}/loadTable${this.params(obj_get)}`;
      }

      axios.get(loadTableUrl).then(res => {
        // console.log(res);
        this.gridOptions.columns = [{ title: this.$t("message.table.linkage") }, ...this.getNewTableTitleData(res.data)];
        var tempOption = this.gridOptions.columns[1]
        this.$set(this.gridOptions.columns, 1, this.gridOptions.columns[0])
        this.$set(this.gridOptions.columns, 0, tempOption)
        console.log(this.gridOptions.columns);
        this.cols = res.data.object.table.columnInfo.ids;

        var img_model = { default: "img1_default" };
        this.gridOptions.columns[1].slots = img_model;
        this.gridOptions.columns[1].width = 80;
        this.rols_text = this.getNewTableContentData(res.data);
        const tableContent = this.getNewTableContentData(res.data);
        if (this.rols_text.length == 0) {
          this.chooseRel = false;
          this.gridOptions.height = 420;
        };

        this.gridOptions.data = this.rols_text;
        const item = getTabIndex()
        const { relRow: { rowIndex = '' } } = item;
        rowIndex !== '' && this.$refs.xGrid.setCurrentRow(this.rols_text[rowIndex]);
        // this.$refs.xGrid.loadData(this.rols_text);
        this.totalRecords = res.data.object.table.totalRecords;
        this.tableShow = true;
        //console.log(this.rols_text);
        this.oldTableValue = tableContent;
        this.version = res.data.object.table.version;
        this.selectRecords = [];
      })

    },

    showDetailEvent(row) {
      console.log(row);

      const obj = {
        id: row.itemId,
        classId: row.itemClassId,
        subClassId: row.itemSubClassId,
        title: row[0]
      };
      this.getLink(obj);
      this.$store.commit("setPageRefresh");

    },

    checkRel(row) {
      //console.log(row);
      this.$store.commit('setTabIndex', { relRow: row })
      this.chooseRel = true;
      this.gridOptions.height = 220;
      this.checkRow = row;
      this.nextCtrObjId = row.row.itemId;
      this.nextCtrObjClassId = row.row.itemClassId;
      this.tabTitle = row.row[0]
      // console.log(this.$store.state.classId_,66662);
      var obj_get = { //获取change
        excludeId: this.$store.state.objectId.id,
        excludeClassId: this.$store.state.objectId.classId,
        ctrObjid: row.row.itemId,
        classId: row.row.itemClassId,
        subClassId: row.row.itemSubClassId,
        tableId: 200,
      };
      //console.log(obj_get);
      var loadTableUrl = `/pmdm/relationship/findRelationShipByExcludeId${this.params(obj_get)}`;

      axios.get(loadTableUrl).then(res => {
        //console.log(res);

        this.gridOption2.columns = [{ title: this.$t("message.table.linkage") }, ...this.getNewTableTitleData(res.data)];
        var tempOption = this.gridOption2.columns[1]
        this.$set(this.gridOption2.columns, 1, this.gridOption2.columns[0])
        this.$set(this.gridOption2.columns, 0, tempOption)
        //console.log(this.gridOption2.columns);
        this.cols2 = res.data.object.table.columnInfo.ids;
        var img_model = { default: "img1_default" };
        this.gridOption2.columns[1].slots = img_model;
        this.gridOption2.columns[1].width = 80;
        this.totalRecord2 = res.data.object.table.totalRecords;
        this.rols_text = this.getNewTableContentData(res.data);
        //this.gridOption2.data = this.rols_text;
        this.$refs.xGridNext.loadData(this.rols_text)
        //console.log(this.gridOption2.data);
        this.selectRecord2 = [];
      })

    },
    cellClassName({ row, rowIndex, column, columnIndex }) {
      //console.log(columnIndex);
      if (row.redText) {
        for (var i = 0; i < row.redText.length; i++) {
          if (columnIndex == row.redText[i]) {
            return "col-red-text";
          };
        }
      } else if (row.redLine) {
        for (var i = 0; i < row.redLine.length; i++) {
          if (columnIndex == row.redLine[i]) {
            return "col-red";
          };
        }
      } else {
        return ''
      };
    },

    loadUserPriv() {
      var priv_ = this.getUserContextPriv();
      // console.log(priv_);
      let subClass_Id = this.$store.state.objectId.subClassId;
      // console.log(subClass_Id);
      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          // console.log(priv_[i]);
          if (priv_[i].type == 3) {
            this.addTableListPriv = true;
          };
          if (priv_[i].type == 4) {
            this.removeTableListPriv = true;
          };
        }
      };

      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (isSupAdmin) {
        this.addTableListPriv = true;
        this.removeTableListPriv = true;
      };
    },

    // setCheck() {

    //   const item = this.$store.state.showingTabsInHome.find((i) => {
    //     const { name } = i;
    //     const { id, classId, subClassId } = this.$store.state.objectId;
    //     const n = "" + id + classId + subClassId;
    //     return name.indexOf(n) != -1;
    //   });
    //   const { relRow: { rowIndex = 2 } } = item

    //   // const { rowIndex = 2 } = relRow
    //   const data = this.gridOptions.data        // console.log(data, relRow.rowIndex);
    //   this.$refs.xGrid.setCurrentRow(data[rowIndex]);
    //   console.log(data, data[rowIndex]);
    //   console.log(rowIndex);
    // }

  },
  created() {
    this.loadUserPriv();
    this.getRelInfo();

  },
  mounted() {
    this.$nextTick(() => {
      const item = getTabIndex();
      const { relRow } = item
      if (!!relRow) {
        this.checkRel(relRow);
        // this.setCheck(relRow)
      }
    })
  },
  computed: {
    loadWorkFlowStatus() {
      return this.$store.state.changeWorkflowStatus;
    },
  },
  props: ['changeValue', 'relUrl', 'type'],
  watch: {
    changeValue: function (value) {
      this.get_change_info = value;
      //console.log(value);
      this.getRelInfo();
    },
    loadWorkFlowStatus: {
      handler(val) {
        const baseId = this.$store.state.objectId.classId.toString().substr(0, 3);
        if (baseId == 104 || base === 401) {
          this.workFlowStatus = !(val == 4)
        } else {
          this.workFlowStatus = true
        }
        //if (baseId == 401) {
        //   this.workFlowStatus = !([3, 4].includes(val))
        // } else if (baseId == 104) {
        //   this.workFlowStatus = !(val == 4)
        // } else {
        //   this.workFlowStatus = true
        // }
        // console.log({ baseId, val, w: this.workFlowStatus });
      },
      deep: true,
      immediate: true,
    },
  }
};
</script>

<style>
.RelSearchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}

.mytable-style .vxe-body--column.col-red {
  text-decoration: line-through;
  color: red;
}

.mytable-style .vxe-body--column.col-red span {
  color: #000;
}

.mytable-style .vxe-body--column.col-red-text {
  color: red;
}

.mytable-style .vxe-body--column.col-red-text span {
  color: red;
}
</style>

<style scoped>
.edit-table {
  margin-left: auto;
}

.line-1 {
  height: 6px;
  background: #ebebeb;
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  height: 40px;
  margin-left: 20px;
}

.content-title li {
  float: left;
  padding: 8px 8px 8px 8px;
  font-size: 14px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}
</style>
